import axios from 'axios';

import { SET_APP_HOME_CONFIG } from './ApphomeTypes';

function setAppHomeConfig(apphome) {
  return {
    type: SET_APP_HOME_CONFIG,
    payload: apphome || {},
  };
}

export function getApphomeConfig(
  wId,
  isInPersonalApphome = false,
  populateButtonCreatorsNames
) {
  return async (dispatch) => {
    try {
      let query = isInPersonalApphome ? `?isInPersonalApphome=true` : '';
      if (populateButtonCreatorsNames) {
        if (query) {
          query = `${query}&populateButtonCreatorsNames=true`;
        } else {
          query = `?populateButtonCreatorsNames=true`;
        }
      }
      const res = await axios.get(`/bot/api/w/${wId}/apphome${query}`);
      if (res.data.success) {
        dispatch(setAppHomeConfig(res.data.apphome));
      } else {
        dispatch(setAppHomeConfig({}));
      }
    } catch (error) {
      // console.log(error);
      dispatch(setAppHomeConfig({}));
    }
  };
}

export function createAndUpdate(wId, data) {
  return (dispatch) => {
    return axios.post(`/bot/api/w/${wId}/apphome`, data).then((res) => {
      // console.log(res.data);
      if (res.data.success) {
        dispatch(setAppHomeConfig(res.data.apphome));
      }
      return res;
    });
  };
}

export function updateApphome(wId, aId, data) {
  // console.log(data);
  return (dispatch) => {
    return axios.put(`/bot/api/w/${wId}/${aId}/apphome`, data).then((res) => {
      if (res.data.success) {
        // console.log(res.data.apphome);
        dispatch(setAppHomeConfig(res.data.apphome));
      }
      return res;
    });
  };
}

export function addAndUpdatePages(wId, aId, data) {
  return (dispatch) => {
    return axios
      .post(`/bot/api/w/${wId}/apphome/${aId}/createAndUpdatePages`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}

export function updatePage(wId, aId, pId, data) {
  return (dispatch) => {
    return axios
      .put(`/bot/api/w/${wId}/apphome/${aId}/${pId}/updatePage`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

export function deletePage(wId, aId, pId) {
  return (dispatch) => {
    return axios
      .delete(`/bot/api/w/${wId}/apphome/${aId}/${pId}/deletePage`)
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}

export function addButtonAction(wId, aId, pId, data) {
  return (dispatch) => {
    return axios
      .post(`/bot/api/w/${wId}/apphome/${aId}/${pId}/createButton`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}

export function updateButtonAction(wId, aId, pId, bId, data) {
  return (dispatch) => {
    return axios
      .put(`/bot/api/w/${wId}/apphome/${aId}/${pId}/${bId}/updateButton`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}

export function deleteButtonAction(wId, aId, pId, bId) {
  return (dispatch) => {
    return axios
      .delete(`/bot/api/w/${wId}/apphome/${aId}/${pId}/${bId}/deleteButton`)
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}

export function resetApphome(wId, aId) {
  return (dispatch) => {
    return axios
      .put(`/bot/api/w/${wId}/${aId}/apphome/reset`, { wId, aId })
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}

export function switchBetweenUserAndWorkspace(wId, aId, data) {
  return (dispatch) => {
    return axios
      .put(
        `/bot/api/w/${wId}/${aId}/apphome/switchBetweenUserAndWorkspace`,
        data
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(setAppHomeConfig(res.data.apphome));
        }
        return res;
      });
  };
}
